import type { Supplier, SupplierStatus } from '@/services/suppliers'

export type SupplierListKpis = {
  total: number
  active: number
  inactive: number
}

export function computeSupplierListKpis(rows: Supplier[]): SupplierListKpis {
  let active = 0
  let inactive = 0
  for (const r of rows) {
    if (r.status === 'ACTIVE') active += 1
    else if (r.status === 'INACTIVE') inactive += 1
  }
  return { total: rows.length, active, inactive }
}

export function countSuppliersByStatus(
  rows: Supplier[],
  status: SupplierStatus,
): number {
  return rows.filter((r) => r.status === status).length
}
